import { use } from 'react'
import useSWR from 'swr'
import { ClientContext } from '../client'

export const useFetchListSchemes = () => {
  const getClient = use(ClientContext)

  const getSchemes = async () => {
    const client = await getClient()
    return await client.ListSchemes({})
  }

  return useSWR('/api/schemes', getSchemes, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })
}
